<template>
  <app-layout :account-global-menu="accountGlobalMenu">
    <template #main-content>
      <main id="content" class="l-main p-account">
        <div class="l-main__inner">
          <div class="c-page-header">
            <button-return @click="goBack" name="S7-2-back-btn">戻る</button-return>
          </div>
          <section v-if="notice!==null">
            <div class="c-parts-box">
              <div class="c-parts-box__inner">
                <div class="c-markdown-area">
                  <div class="c-news-date">
                    <time class="c-news-date__day">{{convertLocalString(notice.start_datetime)}}</time>
                    <span class="c-news-date__tag" v-if="notice.is_important">重要</span>
                  </div>
                  <h1>{{notice.title}}</h1>
                  <markdown-view :rawText="notice.body"></markdown-view>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </template>
  </app-layout>
</template>

<script setup lang="ts">
  import {ref, onMounted} from "vue";
  import {useRoute, useRouter} from "vue-router"
  import { useAccountStore } from '@/store/student/account_store';
  import { useGlobalNavigationStore } from '@/store/student/global_navigation_store';

  const accountGlobalMenu = ref(true)
  const notice = ref(null)
  const accountStore = useAccountStore()
  const globalNavigationStore = useGlobalNavigationStore()
  const route = useRoute()
  const router = useRouter()

  onMounted(async() => {
    document.title = "お知らせ詳細"
    if(accountStore.notificationList.length == 0){
      globalNavigationStore.saveSelectedMenu("acInfo")
      await accountStore.fetchListNotifications()
    }
    let details = accountStore.notificationList.filter((item) => item.uuid==route.params.uuid)
    if(details.length){
      notice.value = details[0]
      await accountStore.fetchReadNotification({'notification_uuid': notice.value.uuid})
      await accountStore.fetchAlreadyReadNotifications()
    }else{
      router.replace({name: 'pageNotFound'}).catch(() => {})
    }
  })
  function goBack(){
    router.go(-1)
  }
  function convertLocalString(date) {
    let dt = new Date(date);
    let y = dt.getFullYear();
    let m = ('00' + (dt.getMonth() +1 )).slice(-2);
    let d = ("00" + dt.getDate()).slice(-2);
    return y + '/' + m + '/' + d;
  }
</script>
